var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojiHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.0001C37.2548 48.0001 47.9999 37.2588 47.9999 24.0087C47.9999 10.7585 37.2548 0.0172119 24 0.0172119C10.7452 0.0172119 0 10.7585 0 24.0087C0 37.2588 10.7452 48.0001 24 48.0001Z",
    fill: "#CC0000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.0001C37.2548 48.0001 47.9999 37.2588 47.9999 24.0087C47.9999 10.7585 37.2548 0.0172119 24 0.0172119C10.7452 0.0172119 0 10.7585 0 24.0087C0 37.2588 10.7452 48.0001 24 48.0001Z",
    fill: "url(#paint0_radial_733_12616)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 35.7234L23.4434 35.3615C22.9762 35.0574 12 27.8389 12 21.3291C12 16.6991 15.3061 14.2766 18.5718 14.2766C20.6595 14.2766 22.6149 15.2462 23.9992 16.9218C25.3791 15.2492 27.3373 14.2766 29.4287 14.2766C32.6944 14.2766 36 16.6992 36 21.3291C36 27.8384 25.0236 35.0571 24.5566 35.3615L23.9995 35.7234Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_733_12616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35 14.5001) rotate(133.995) scale(60.4669 60.4884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0000",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiHeart);
export default __webpack_public_path__ + "static/media/emoji-heart.43a3204da1099b3b8746948af9c15df0.svg";
export { ForwardRef as ReactComponent };